/** Anchos columna C y D+E (plantilla Invoice 5019). */
const W_LABEL = 41.44;
const W_VALUE = 54.44 + 66.78;

function estimateWrappedLines(text, colWidthExcel) {
  const s = String(text ?? '');
  if (!s) return 1;
  const charsPerLine = Math.max(14, Math.floor(colWidthExcel * 1.05));
  return s.split('\n').reduce((sum, para) => {
    const t = para.trim();
    if (!t) return sum;
    return sum + Math.max(1, Math.ceil(t.length / charsPerLine));
  }, 0);
}

/** Altura total del bloque (pt): líneas + margen arriba/abajo para no pegar al borde. */
function blockHeightPt(lineCount) {
  if (lineCount <= 0) return 10;
  const pad = 6.5;
  return Math.max(12, lineCount * 10.1 + pad);
}

function raiseRow(ws, row, height) {
  const current = ws.getRow(row).height || 0;
  if (height > current) ws.getRow(row).height = height;
}

/** Filas 27–28 o 29–30: no baja de la altura de Invoice 5019. */
export function applyHtLabelValuePairRowHeights(ws, row1, row2, leftLabels, rightValue) {
  const leftLines = leftLabels.reduce((n, t) => n + estimateWrappedLines(t, W_LABEL), 0);
  const rightLines = estimateWrappedLines(rightValue, W_VALUE);
  const each = blockHeightPt(Math.max(leftLines, rightLines)) / 2;
  raiseRow(ws, row1, each);
  raiseRow(ws, row2, each);
}

export function applyHtLabelValueRowHeight(ws, row, label, value) {
  const lines = Math.max(estimateWrappedLines(label, W_LABEL), estimateWrappedLines(value, W_VALUE));
  raiseRow(ws, row, blockHeightPt(lines));
}
